var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdamosLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Adamos auf wei\xDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button_Mit-Adamos-anmelden",
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Adamos-ohne-outline",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 0,
    y: 0.0845070423,
    width: 36,
    height: 35.8309859,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(6.591549, 5.746479)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#008DAB",
    points: "7.84729499 17.4084507 11.3933279 7.12602456 11.3954712 7.13450666 13.8591549 0 8.63494509 0 2.53521127 17.4084507"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#B9E0E3",
    points: "17.3726249 24.5070423 22.6478873 24.5070423 15.2780511 3.21126761 12.6760563 10.8036466"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#00B4CD",
    points: "13.2534243 19.7746479 1.6434935 19.7746479 0 24.5070423 14.8732394 24.5070423"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdamosLogo);
export default __webpack_public_path__ + "static/media/AdamosLogo.7ca4ef5d.svg";
export { ForwardRef as ReactComponent };